import * as React from 'react';

import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { IVariantsProps } from '../../../../model';
import { Container, VariantList } from '../../variantsStyled';

import { VariantTile } from './VariantTile';

export const VariantsTile: React.FC<IVariantsProps> = ({
  locale,
  selectedId,
  variants,
  currency,
}) => {
  const newDesign = useNewPdDesignEnabled();

  return (
    <Container id="pdVariantsTile" newDesign={newDesign}>
      <VariantList newDesign={newDesign} itemsCount={variants.length}>
        {variants.map((item) => (
          <VariantTile
            item={item}
            locale={locale}
            unit={item.parameters?.unit}
            isSelected={item.webId === selectedId}
            currency={currency}
            key={item.webId}
          />
        ))}
      </VariantList>
    </Container>
  );
};
